export const uuidValidator: RegExp = new RegExp(
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i
);

export const hashValidator: RegExp = new RegExp(/^[a-fA-F0-9]{32}$/);

export const ean13BarcodeValidator: RegExp = new RegExp(/^[0-9]{13}$/);
export const ean8BarcodeValidator: RegExp = new RegExp(/^[2-9][0-9]{7}$/);
export const itfBarcodeValidator: RegExp = new RegExp(/^[0-9]{6,14}$/);
export const upcABarcodeValidator: RegExp = new RegExp(/^[0-9]{12}$/);
export const upcEBarcodeValidator: RegExp = new RegExp(/^[0-9]{6,8}$/);

export const supportedBarcodesValidators: RegExp[] = [
  ean13BarcodeValidator,
  ean8BarcodeValidator,
  itfBarcodeValidator,
  upcABarcodeValidator,
  upcEBarcodeValidator,
];
